import Sidebar from "../../Component/sidebar";
import { Route, Routes } from "react-router-dom";
import { CxoSidebarData } from "../../module/cxoSidebarData";
import TransactionDetails from "./TransactionDetails/transactionDetails";
import SourceWiseAnalysis from "./RevenueAnalysis/sourceWiseAnalysis";
import StateWiseAnalysis from "./RevenueAnalysis/stateWiseAnalysis";
import ProductWiseAnalysis from "./RevenueAnalysis/productWiseAnalysis";
import RegisterdUser from "./LeadDetails/registerdUser";
import AllSourceLeadCount from "./LeadDetails/allSourceLeadCount";
import StateWiseLeadCount from "./LeadDetails/stateWiseLeadCount";
import SellingSrcRevenueAnlysis from "./sellingSrcRevenueAnlysis";
import ProductOrderHistory from "./productOrderHistory";
import StockAnalysis from "./StockAnalysis/stockAnalysis";
import SellingSourceWiseAnalysis from "./SellingSourceWiseAnalysis/sellingSourceWiseAnalysis";
const CxoDashboard = () => {
  return (
    <>
      <div className="adminDiv d-flex">
        <Sidebar data={CxoSidebarData} />
        <div className="rightSideContainer py-3 px-4">
          <Routes>
            <Route path="/" element={<TransactionDetails />} />
            <Route path="transactionDetails" element={<TransactionDetails />} />
            <Route path="sourceWiseAnalysis" element={<SourceWiseAnalysis />} />
            <Route path="stateWiseAnalysis" element={<StateWiseAnalysis />} />
            <Route path="productWiseAnalysis" element={<ProductWiseAnalysis />} />
            <Route path="registerdUser" element={<RegisterdUser />} />
            <Route path="allsourceLead" element={<AllSourceLeadCount />} />
            <Route path="stateLead" element={<StateWiseLeadCount />} />
            <Route path="sellingSrcRevenueAnlysis" element={<SellingSrcRevenueAnlysis />} />
            <Route path="productOrderHistory" element={<ProductOrderHistory />} />
            <Route path="/stockAnalysis" element={<StockAnalysis />} />
            <Route path="/sellingSourceWiseAnalysis" element={<SellingSourceWiseAnalysis />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default CxoDashboard;
